import { Alert, Typography } from "@mui/material";
import { CacheTable } from "components/cacheAdmin/CacheTable";
import { AccountPageLayout } from "components/common/AccountPageLayout";
import { Fetching } from "components/common/loading/fetching";
import { isFetchBaseQueryError } from "helpers";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { useCallback } from "react";
import {
  useGetCacheLinesQuery,
  useInvalidateCacheLinesMutation,
} from "src/store/api/generatedApi";

export const CacheAdminPage = () => {
  const { t } = useTenantTranslation();
  return (
    <AccountPageLayout title={t("cacheAdmin")}>
      <Content />
    </AccountPageLayout>
  );
};

const Content = () => {
  const { t } = useTenantTranslation();
  const tenantName = useTenant();
  const { data, isLoading, isFetching, error } = useGetCacheLinesQuery({
    tenantName,
  });
  const [invalidateKeys] = useInvalidateCacheLinesMutation();

  const _invalidateKeys = useCallback(
    (keys: string[]) => invalidateKeys({ tenantName, cacheLineKeys: { keys } }),
    [tenantName, invalidateKeys]
  );

  if (error) {
    const detail = isFetchBaseQueryError(error)
      ? typeof error.data === "string"
        ? error.data
        : JSON.stringify(error.data)
      : (error as { message?: string }).message;

    return (
      <Alert severity="error">
        {t("unknownError")}
        {detail ? (
          <Typography variant="body2" sx={{ mt: 1 }}>
            {detail}
          </Typography>
        ) : null}
      </Alert>
    );
  }
  return (
    <Fetching fetching={isFetching} sx={{ flex: 1, overflow: "hidden" }}>
      <CacheTable
        invalidateKeys={_invalidateKeys}
        lines={data?.lines ?? []}
        isLoading={isLoading}
      />
    </Fetching>
  );
};
